import { computed, ref, Ref, watch } from "vue";
import { GenericField } from "@/business/shared/commons/validator/validatorsTypes";
import { RequiredRule } from "@/business/shared/commons/validator/rules/RequiredRule";
import { EmailRule } from "@/business/shared/commons/validator/rules/EmailRule";
import { NumericRule } from "@/business/shared/commons/validator/rules/NumericRule";
import { PasswordRule } from "@/business/shared/commons/validator/rules/PasswordRule";
import { validator } from "@/business/shared/commons/validator/validator";

export function createEditUserValidator() {
  const name: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El mombre es obligatorio")],
  });
  const userName: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El nombre de usuario es obligatorio")],
  });
  const role: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [new RequiredRule("El rol es obligatorio")],
  });
  const code: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule("El código empleado es obligatorio"),
      new NumericRule("El código empleado debe ser numérico"),
    ],
  });
  const price: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule("El precio base es obligatorio"),
      new NumericRule("El precio debe ser numérico"),
    ],
  });
  const password: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule("La contraseña es obligatoria"),
      new PasswordRule(
        "Formato de contraseña no válido. Mínimo 8 caracteres, un número y un caracter especial"
      ),
    ],
  });
  const email: Ref<GenericField> = ref({
    enabled: false,
    errors: [],
    isSuccess: true,
    val: "",
    rules: [
      new RequiredRule("El correo es obligatorio"),
      new EmailRule("El correo debe tener un formato válido"),
    ],
  });

  watch(
    () => name.value.val,
    () => {
      if ((name.value.val?.length ?? 0) > 0) {
        name.value.enabled = true;
      }
    }
  );
  watch(
    () => userName.value.val,
    () => {
      if ((userName.value.val?.length ?? 0) > 0) {
        userName.value.enabled = true;
      }
    }
  );
  watch(
    () => role.value.val,
    () => {
      if ((role.value.val?.length ?? 0) > 0) {
        role.value.enabled = true;
      }
    }
  );
  watch(
    () => code.value.val,
    () => {
      if ((code.value.val?.length ?? 0) > 0) {
        code.value.enabled = true;
      }
    }
  );
  watch(
    () => price.value.val,
    () => {
      if ((price.value.val?.length ?? 0) > 0) {
        price.value.enabled = true;
      }
    }
  );
  watch(
    () => password.value.val,
    () => {
      if ((password.value.val?.length ?? 0) > 0) {
        password.value.enabled = true;
      }
    }
  );
  watch(
    () => email.value.val,
    () => {
      if ((email.value.val?.length ?? 0) > 0) {
        email.value.enabled = true;
      }
    }
  );

  function validate(field: GenericField, otherValue?: string): GenericField {
    return validator().validateField(field, otherValue);
  }

  const successForm = computed(() => {
    name.value = validate(name.value);
    userName.value = validate(userName.value);
    role.value = validate(role.value);
    code.value = validate(code.value);
    price.value = validate(price.value);
    password.value = validate(password.value);
    email.value = validate(email.value);

    return !(
      name.value.isSuccess &&
      userName.value.isSuccess &&
      role.value.isSuccess &&
      code.value.isSuccess &&
      price.value.isSuccess &&
      password.value.isSuccess &&
      email.value.isSuccess
    );
  });

  const successFormEdit = computed(() => {
    name.value = validate(name.value);
    userName.value = validate(userName.value);
    role.value = validate(role.value);
    code.value = validate(code.value);
    price.value = validate(price.value);
    email.value = validate(email.value);

    return !(
      name.value.isSuccess &&
      userName.value.isSuccess &&
      role.value.isSuccess &&
      code.value.isSuccess &&
      price.value.isSuccess &&
      email.value.isSuccess
    );
  });

  function reset(): void {
    name.value.val = "";
    userName.value.val = "";
    role.value.val = "";
    code.value.val = "";
    price.value.val = "";
    password.value.val = "";
    email.value.val = "";
    name.value.enabled = false;
    userName.value.enabled = false;
    role.value.enabled = false;
    code.value.enabled = false;
    price.value.enabled = false;
    password.value.enabled = false;
    email.value.enabled = false;
  }

  return {
    name,
    userName,
    role,
    code,
    price,
    password,
    email,
    successForm,
    successFormEdit,
    reset,
  };
}
